import React from "react";
import { Link } from "react-router-dom";
import { Shield, MapPin } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_nextday-app/artifacts/pdlzpvcf_NextDayRefund.com-Logo.png";

const LOGO_STYLE = {
  width: "240px",
  height: "39px",
  backgroundImage: `url(${LOGO})`,
  backgroundSize: "384px auto",
  backgroundPosition: "-63px -104px",
  backgroundRepeat: "no-repeat",
};

export default function Footer() {
  return (
    <footer className="bg-[#0F172A] text-white border-t border-white/5">

      {/* White logo band — matches the white navbar for brand consistency */}
      <div className="bg-white border-b border-slate-200">
        <div className="section-container py-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <Link to="/" data-testid="footer-logo">
            <div style={LOGO_STYLE} role="img" aria-label="NextDayRefund.com" />
          </Link>
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <Shield size={14} className="text-[#2ECC71]" />
              Verified Provider Network
            </div>
            <div className="flex items-center gap-2 text-sm text-slate-500">
              <MapPin size={14} className="text-[#2ECC71]" />
              All 50 US States
            </div>
            <Link to="/claim"
              className="btn-action !py-2 !px-4 !text-sm whitespace-nowrap"
              data-testid="footer-claim-cta">
              Claim Your Zip — $150
            </Link>
          </div>
        </div>
      </div>

      {/* Dark links body */}
      <div className="section-container py-10">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-8">

          <div>
            <p className="text-slate-300 text-sm leading-relaxed">
              Connecting taxpayers with verified local professionals who offer next-day refund advances — and giving local businesses exclusive ZIP code advertising spots across 12 industries.
            </p>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4 text-xs uppercase tracking-widest">For Taxpayers</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/find-provider" className="hover:text-white transition-colors" data-testid="footer-find-provider">Find a Provider</Link></li>
              <li><Link to="/#how-it-works" className="hover:text-white transition-colors">How It Works</Link></li>
              <li><Link to="/map" className="hover:text-white transition-colors" data-testid="footer-map">Territory Map</Link></li>
              <li><Link to="/competitive-zips" className="hover:text-white transition-colors" data-testid="footer-competitive-zips">Most Competitive ZIPs</Link></li>
              <li><Link to="/jobs" className="hover:text-white transition-colors" data-testid="footer-jobs">Jobs Board</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-bold text-white mb-4 text-xs uppercase tracking-widest">For Advertisers</h4>
            <ul className="space-y-2.5 text-sm text-slate-400">
              <li><Link to="/for-tax-pros" className="hover:text-white transition-colors">Why Advertise</Link></li>
              <li><Link to="/advertise" className="hover:text-white transition-colors">All Industries</Link></li>
              <li><Link to="/claim" className="hover:text-white transition-colors">Claim Your Zip</Link></li>
              <li><Link to="/portal" className="hover:text-white transition-colors">Partner Portal</Link></li>
              <li><Link to="/register" className="hover:text-white transition-colors">Register</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-slate-500 text-xs text-center sm:text-left">
            © {new Date().getFullYear()} NextDayRefund.com | Affordable Advertising Solutions LLC. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs flex-wrap justify-center">
            <Link to="/terms" className="text-slate-500 hover:text-white transition-colors" data-testid="footer-terms">Terms &amp; Conditions</Link>
            <Link to="/privacy" className="text-slate-500 hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
            <span className="text-[#2ECC71] font-semibold">All 50 US States</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
